module.exports = __webpack_public_path__ + "img/nothing.8e574b26.png";